import { useState, useEffect } from "react";
import deliveryVan from "../images/delivery_van_transparent.png";
import deliveryBag from "../images/delivery_bag_transparent.png";

const HowWeDeliver = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = [
    { src: deliveryVan, alt: "Delivery Van" },
    { src: deliveryBag, alt: "Delivery Bag" }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section className="relative bg-gradient-to-br from-green-950 via-emerald-900 to-green-950 py-20 overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-10 left-10 w-32 h-32 bg-emerald-500 rounded-full opacity-10 blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-40 h-40 bg-green-400 rounded-full opacity-10 blur-3xl"></div>
        <div className="absolute top-1/2 left-1/3 w-24 h-24 bg-emerald-600 rounded-full opacity-5 blur-2xl animate-[float_3s_ease-in-out_infinite]"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">How We Deliver</h2>
          <p className="text-emerald-300 text-lg">Fresh, Healthy Meals Right to Your Doorstep</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-7xl mx-auto">
          {/* Left: Delivery Process Steps */}
          <div className="space-y-6">
            <StepCard
              number="1"
              title="Order Confirmation"
              description="Place your order before 8 PM. Please allow 2 days for fresh preparation. Choose your meal plan and delivery schedule."
            />
            <StepCard
              number="2"
              title="Fresh Preparation"
              description="Our chefs prepare your meals fresh every morning using premium ingredients and sealed in eco-friendly packaging."
            />
            <StepCard
              number="3"
              title="Temperature-Controlled Delivery"
              description="We use insulated bags to maintain optimal temperature during transit."
            />
            <StepCard
              number="4"
              title="Delivered to Your Location"
              description="Receive your fresh meals between 6 AM - 9 AM. Track your delivery by contacting us directly."
            />
          </div>

          {/* Right: Delivery Image Illustration */}
          <div className="relative">
            {/* Main Container with Glow Effect */}
            <div className="bg-gradient-to-br from-emerald-900/40 to-green-900/40 rounded-3xl p-8 backdrop-blur-sm border border-emerald-600/20 shadow-[0_0_40px_rgba(16,185,129,0.3)]">
              {/* Image Slider */}
              <div className="relative w-full aspect-[4/3] overflow-hidden rounded-xl">
                {images.map((img, index) => (
                  <img
                    key={index}
                    src={img.src}
                    alt={img.alt}
                    className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-1000 ${index === currentImageIndex ? 'opacity-100' : 'opacity-0'
                      }`}
                  />
                ))}
              </div>

              {/* Delivery Info Cards */}
              <div className="grid grid-cols-2 gap-4 mt-6">
                <div className="bg-emerald-800/30 rounded-lg p-3 text-center">
                  <p className="text-emerald-400 text-xs mb-1">Delivery Time</p>
                  <p className="text-white font-bold">6 AM - 9 AM</p>
                </div>
                <div className="bg-emerald-800/30 rounded-lg p-3 text-center">
                  <p className="text-emerald-400 text-xs mb-1">Coverage Area</p>
                  <p className="text-white font-bold">All over Dubai</p>
                </div>
              </div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -top-4 -right-4 bg-gradient-to-br from-yellow-400 to-orange-500 text-white rounded-full p-4 shadow-lg animate-bounce">
              <div className="text-center leading-tight">
                <div className="text-xs font-bold">FREE</div>
                <div className="text-[10px]">Delivery</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

// Step Card Component
const StepCard = ({ number, title, description }) => {
  return (
    <div className="bg-green-900/30 backdrop-blur-sm rounded-2xl p-6 border border-emerald-700/30 hover:border-emerald-500/50 transition-all duration-300 hover:scale-105">
      <div className="flex items-start space-x-4">
        <div className="bg-emerald-500 text-green-950 w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl flex-shrink-0">
          {number}
        </div>
        <div>
          <h3 className="text-xl font-semibold text-white mb-2">{title}</h3>
          <p className="text-emerald-200">{description}</p>
        </div>
      </div>
    </div>
  );
};

const FeatureCard = null; // Removing the component definition or just deleting it if it is unused. 
// Actually, it's safer to just delete the block.


export default HowWeDeliver;